import { InvoiceTabEnum } from 'containers/invoices/create-invoice/constants';
import { useAppSelector } from 'hooks';
import { FC, useContext } from 'react';
import DateUtils from 'utils/dateUtils';
import { selectInvoiceOptionsEditPage } from '../invoicesEditSlice';

interface InvoiceOptionsSectionProps {
  className?: string;
  context: React.Context<any>;
}

const InvoiceSection: FC<InvoiceOptionsSectionProps> = ({ context }) => {
  const { selectedInvoiceTab } = useContext<any>(context);
  const selectedInvoiceOptionsEditPage = useAppSelector(selectInvoiceOptionsEditPage);

  const isTabSelected = selectedInvoiceTab === InvoiceTabEnum.INVOICE_OPTIONS;

  const renderDate = dateString => {
    let date = dateString || DateUtils.getToday();
    date = DateUtils.getDateInFormat({ date: new Date(date), dateFormat: 'dd MMM yyyy' });
    return date;
  };
  return (
    <div>
      <div className={`mb-2 text-heading font-bold text-xl ${isTabSelected ? 'text-primaryBtn' : 'text-heading'}`}>
        Invoice options
      </div>
      <div
        className={`flex flex-row flex-wrap justify-between gap-4 rounded-md border px-[30px] py-5
         lg:gap-8 xl:gap-40 1439px:p-10 ${isTabSelected ? 'border-primaryBtn' : 'border-borderGray'}`}>
        <div className="flex flex-row gap-5 text-17px">
          {/* create invoice -> current date, edit invoice -> .createdAt */}
          <div className="whitespace-nowrap text-primaryText font-semibold">Invoice date</div>
          <div className="whitespace-nowrap text-accentText font-semibold">
            {renderDate(selectedInvoiceOptionsEditPage.createdAt)}
          </div>
        </div>
        <div className="flex flex-row gap-5 text-17px">
          {/* create invoice -> upon receipt, edit invoice -> .dueDate */}
          <div className="whitespace-nowrap text-primaryText font-semibold">Due date</div>
          <div className="whitespace-nowrap text-accentText font-semibold">
            {renderDate(selectedInvoiceOptionsEditPage.dueDate)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSection;
